import { appById, appsForExtension } from './apps.js';
import { chooseAppDialog } from './dialog.svelte.js';
import { getNode } from './filesystem.svelte.js';
import { addRecent } from './recents.svelte.js';
import { launchApp } from './windows.svelte.js';

export function extensionFor(name = '') {
  const dot = name.lastIndexOf('.');
  return dot > -1 ? name.slice(dot).toLowerCase() : '';
}

export async function openFile(nodeOrPath, preferredAppId = null) {
  const node = typeof nodeOrPath === 'string' ? getNode(nodeOrPath) : nodeOrPath;
  if (!node) return null;
  addRecent({ kind: 'file', id: node.path, label: node.name, icon: node.icon });

  if (node.kind === 'folder') {
    return launchApp(appById('projects'), { initialPath: node.path });
  }
  if (node.kind === 'app' || node.appId) {
    return launchApp(appById(node.appId));
  }

  const candidates = appsForExtension(extensionFor(node.name));
  let target = preferredAppId ? appById(preferredAppId) : candidates[0];
  if (!target) {
    const appId = await chooseAppDialog({ file: node, apps: [appById('textedit'), appById('preview')].filter(Boolean) });
    target = appById(appId);
  }
  if (!target) return null;

  return launchApp(target, {
    documentPath: node.path,
    documentId: node.id,
    documentName: node.name,
  });
}
